var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTuner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.25,
    height: 14.25,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16346 7.23715L4.16346 15.4583M4.16346 1.20831V3.40062M11.8365 13.266V15.4583M11.8365 1.20831V9.42947M2.375 7.23717H5.95192C6.78035 7.23717 7.45192 6.5656 7.45192 5.73717V4.90063C7.45192 4.07221 6.78035 3.40063 5.95192 3.40063H2.375C1.54657 3.40063 0.875 4.07221 0.875 4.90063V5.73717C0.875 6.5656 1.54657 7.23717 2.375 7.23717ZM10.0481 13.266H13.625C14.4534 13.266 15.125 12.5944 15.125 11.766V10.9295C15.125 10.101 14.4534 9.42947 13.625 9.42947H10.0481C9.21965 9.42947 8.54807 10.101 8.54807 10.9295V11.766C8.54807 12.5944 9.21965 13.266 10.0481 13.266Z",
    stroke: "#5F4840",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuner);
export default __webpack_public_path__ + "static/media/tuner.54ba2f7a3f1de2cf66290d037c36840b.svg";
export { ForwardRef as ReactComponent };